<template>
    <div>
        <div class="d-flex flex-row-reverse mt-3 addBtn">
            <button type="button" class="btn bg-new-primary f-14 h-100"  data-toggle="modal" data-target="#addProcessModal">
                <i class="fa fa-plus f-14 mr-2"></i> {{$ml.get('CREATE_PROCESS')}}
            </button>   
        </div> 
        <div class="container mt-3">
            <grid v-if="windowWidth>maxMobilSize" @editProcess="getProcessId($event)" :columns="gridColumns" :tableConfigVisible="tableConfigVisible" :user="user" :users="users" :page="pageIs" :data="gridData"></grid>
            <gridMobil v-else :columns="gridColumns" @editProcess="getProcessId($event)" :tableConfigVisible="tableConfigVisible" :user="user" :users="users" :data="gridData" :page="pageIs" ></gridMobil>
        </div>

        <!-- create process modal begin-->
        <div class="modal fade" id="addProcessModal" tabindex="-1" aria-labelledby="addProcessModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title createProcessModalHeader" id="addProcessModalLabel">{{$ml.get('CREATE_PROCESS')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-3 pb-5">
                   <div class="row">
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('PROCESS_NAME')}}</label>
                            <input type="text" v-model="processName" class="new-input">
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label class="new-label">{{$ml.get('FORMS')}}</label>
                            <select class="new-select bg-white" @change="changeForm($event)">
                              <option selected disabled>{{$ml.get('SELECT')}}</option>
                              <option v-for="(form,index) in listForms" :key="index" :selected="selectedForm===form._id">{{form.name}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer noteBtnStyle">
                    <button @click="closeButton()" type="button" class="btn-new" data-dismiss="modal">{{$ml.get('CANCEL')}}</button>
                    <button @click="addProcessF()" data-dismiss="modal" type="button" class="btn-new save ml-1">{{$ml.get('SAVE')}}</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { mapState,mapActions } from 'vuex'
import Grid from './Grid'
import GridMobil from "./gridMobil";

export default {
    name: 'processesDetailPanel',
    components: {
        "grid":Grid,
        "gridMobil":GridMobil,
    },
    data () {
        return {
            gridColumns:[
                {prop:'_id',name:"Id",default:true},
                {prop:'name',name:this.$ml.get('PROCESS_NAME'),default:true,type:"name",valid:true},
                {prop:'form',name:this.$ml.get('FORM_NAME'),default:true,type:"formObj",valid:true},
                {prop:'add_date',name:this.$ml.get('CREATION_DATE'), type:"dateObj", default:true, valid:true},
                {prop:'current_step',name:this.$ml.get('STEP_NAME'),default:true, type:"stepObj",valid:true},
                {prop:'cuid', name: this.$ml.get('CREATED_BY'), type:"user", default:true},
            ],
            tableConfigVisible:[],
            pagingSize:30,
            pagingOffset:0,
            pageIs:'process',
            firstLoad:true,
            gridData:[],
            processesRow:[],
            user:{},
            users:[],
            permissions:[],
            listForms: [],
            processName: "",
            selectedForm: "",
            stepId: ""
        }
    },
    computed: {
        ...mapState([
            'baseUrl',
            'windowWidth',
            'maxMobilSize',
        ]),
    },
    props:["dataId", "field"],
    mounted(){
        this.getUsersF()
    },
    methods:{
        closeButton(){
            $('#createProcessAlertModal').modal('show')
            this.clearModal()
        },
        clearModal(){
            this.selectedForm = ""
            this.processName = ""
            this.stepId = ""
        },
        changeForm(event){
            this.selectedForm=this.listForms[event.target.selectedIndex-1]._id.$oid
            this.stepId=this.listForms[event.target.selectedIndex-1].flow.sequence[0]
        },
        checkParameters(){
            var check = true

            if(this.processName == "" || this.stepId == "" || this.selectedForm == "" || this.field == null || this.field == undefined ){
                check = false
            }

            return check
        },
        addProcessF(){
            if(this.checkParameters()){
                let obj = {}

                obj.form_id = this.selectedForm
                obj.data = {}
                obj.current_step = this.stepId
                obj.name = this.processName
                obj.customerFileIds = []

                if(this.field == 'organization'){
                    obj.company_id = this.dataId
                }
                if(this.field == 'contact'){
                    obj.person_id = this.dataId
                }
                if(this.field == 'deal'){
                    obj.deal_id = this.dataId
                }

                console.log(obj);

                axios({
                    method:'POST',
                    url:'/addProcess',
                    baseURL: this.baseUrl,
                    data: obj,
                    withCredentials:true
                    }).then((res)=>{
                        return res
                    }).then((res)=>{
                    if(res.data.status){
                        if(res.data.status.code==0){
                            this.getProcessesF()
                            this.clearModal()
                        }else{
                            alert("hata")
                        }
                    }else{
                   
                    }
                })
            }
            else{
                this.$notify({ 
                    group: 'foo',
                    type: 'warning', 
                    title: this.$ml.get('WARNING'),
                    text: "Process name ve forms alanı boş geçilemez."
                })
                this.clearModal()
            }
        },
        getProcessId(id){
            this.getProcessF(id)
        },
        async getProcessF(id){
            await this.$router.push('/process')
            this.$root.$refs.formProcess.getProcessF(id)
        },
        getProcessesF(){
            axios({
                method:'POST',
                url:'/getProcesses',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        if(this.firstLoad){
                            for(var col in this.gridColumns){
                                if(this.gridColumns[col]['default']){
                                    this.tableConfigVisible.push(this.gridColumns[col]['prop'])
                                }
                            }
                        }
                        this.firstLoad=false

                        var filteredProcesses

                        if(this.field == 'organization'){
                            filteredProcesses = res.data.content.processes[0].filter(obj => (obj.hasOwnProperty("company_id") ? obj.company_id.$oid == this.dataId : ""));
                        }
                        else if(this.field == 'contact'){
                            filteredProcesses = res.data.content.processes[0].filter(obj => obj.person_id == this.dataId);
                        }
                        else if(this.field == 'deal'){
                            filteredProcesses = res.data.content.processes[0].filter(obj => obj.deal_id == this.dataId);
                        }
                        
                        if(filteredProcesses){
                            var processList = []
                            let columns = this.gridColumns
                            for (var processObjIter in filteredProcesses){
                                this.processesRow.push(filteredProcesses[processObjIter])
                                let obj={}
                                let processObj = filteredProcesses[processObjIter]
                                for(var column in columns){
                                    var colInActivity = processObj.hasOwnProperty(columns[column]['prop'])

                                    if(colInActivity){
                                        
                                        let edObj={}

                                        if(columns[column]['type']==='stepObj'){
                                            
                                            edObj['val']=processObj.form.flow.steps[processObj['current_step']]
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            // edObj['current_step']=processObj[columns[column]['prop']]
                                            obj[columns[column]['prop']]=edObj
                                            
                                        }else{
                                            edObj['val']=processObj[columns[column]['prop']]
                                            edObj['isEditMode']=false
                                            edObj['type']=columns[column]['type']
                                            obj[columns[column]['prop']]=edObj
                                        }

                                    }
                                    else{
                                        let edObj={}
                                        edObj['val']=null
                                        edObj['isEditMode']=false
                                        edObj['type']=columns[column]['type']
                                        if(columns[column]['type']=='dateObj'){
                                            let date = {}
                                            date['$date']=''
                                            edObj['val']=date
                                            
                                        }
                                        obj[columns[column]['prop']]=edObj
                                    }
                                }
                                processList.push(obj)
                                
                            }
                            this.gridData = processList
                            processList.reverse()
                        }
                    }
                }else{
                    
                }
            })
        },
        getAllFormsF(){
            axios({
                method:'POST',
                url:'/getAllForms',
                baseURL: this.baseUrl,
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.listForms = res.data.content.forms[0].reverse()
                    }
                }else{

                }
            })
        },
        getUsersF(){
             axios({
                method:'POST',
                url:'/getUsers',
                baseURL: this.baseUrl,
                data: {
                },
                withCredentials:true
                }).then((res)=>{
                    return res
                }).then((res)=>{
                if(res.data.status){
                    if(res.data.status.code==0){
                        this.user=res.data.content.user
                        this.users=res.data.content.users
                        this.permissions=res.data.content.permissions
                        this.getProcessesF()
                        this.getAllFormsF()
                    }
                }
            })
        },
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
